import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDWYRJ5xLxxfxaXmXMX3ZuZF_HX9uDZzgY",
    authDomain: "urbam-reactapp.firebaseapp.com",
    projectId: "urbam-reactapp",
    storageBucket: "urbam-reactapp.appspot.com",
    messagingSenderId: "503279598080",
    appId: "1:503279598080:web:1814c7c3a256ce8c9e76e5"
};

const firebaseApp = initializeApp(firebaseConfig);

const db = getFirestore(firebaseApp)

export { db };